"use client";
import { useState, useEffect } from "react";

function useInteractionStart() {
  const [isInteracting, setIsInteracting] = useState(false);

  useEffect(() => {
    const handleInteractionStart = () => {
      setIsInteracting(true);
    };

    // Add event listeners for scroll, touchstart, and mousedown events
    window.addEventListener("scroll", handleInteractionStart, { once: true });
    window.addEventListener("touchstart", handleInteractionStart, {
      once: true,
    });
    window.addEventListener("mousedown", handleInteractionStart, {
      once: true,
    });

    // Cleanup event listeners when component unmounts
    return () => {
      window.removeEventListener("scroll", handleInteractionStart);
      window.removeEventListener("touchstart", handleInteractionStart);
      window.removeEventListener("mousedown", handleInteractionStart);
    };
  }, []);

  return { isInteracting };
}

export default useInteractionStart;
